import * as SwitchPrimitives from "@radix-ui/react-switch"
import * as React from "react"

import { cn } from "../lib/utils"

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    size?: "sm" | "md" | "compact"
  }
>(({ className, size = "md", ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      size === "sm"
        ? "h-3 w-6 border-2 border-transparent"
        : size === "compact"
          ? "h-[18px] w-[36px] p-px"
          : "h-6 w-11 border-2 border-transparent",
      "peer inline-flex shrink-0 cursor-pointer items-center rounded-full transition-colors",
      "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 focus-visible:ring-offset-background",
      "disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-border",
      className
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        size === "sm" ? "h-2.5 w-2.5" : size === "compact" ? "size-4" : "h-5 w-5",
        "pointer-events-none block rounded-full bg-bg-white shadow-lg ring-0",
        "transition-transform data-[state=unchecked]:translate-x-0",
        size === "sm"
          ? "data-[state=checked]:translate-x-2.5"
          : size === "compact"
            ? "data-[state=checked]:translate-x-[18px]"
          : "data-[state=checked]:translate-x-5"
      )}
    />
  </SwitchPrimitives.Root>
))
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
